import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import Source from "../../../Source";
import axios from "axios";
import Swal from "sweetalert2";
import Profile from "../../../assets/icon/profile.png";
import IdNational from "../../../assets/icon/national_id.png";
import Datepicker_Customer from "../../forms/Datepicker_customer";
import moment from "moment-jalaali";
import jalaali from "jalaali-js";
import Combo_stock from "../../forms/Combo_Customer";
import Combo_stockps from "../../psbox/Combo_Customer";
import Combo_item from "../../forms/Combo_Customer";
import Additem from "./AddItem";
import Money from "../../Money";
import Combo_Customer from "../../psbox/Combo_Customer";
import ComboBox from "../../forms/ComboBox";
import Trash from "../../../assets/icon/trash.png";
import Print from "../../../assets/icon/print.png";
import Add from "../../../assets/icon/add.png";
import jsPDF from "jspdf";
import { useSelector, useDispatch } from 'react-redux';
import { showAlert } from "../../../warrper";
// import { getBelances } from "../../Redux/belanceSlice";
import { getMoneys } from "../../Redux/moneysSlice";
import { getCustomers } from "../../Redux/customerSlice";
// import { getReports } from "../../Redux/reportSlice";
import { getItems } from "../../Redux/itemSlice";
// import { useSelector, useDispatch } from 'react-redux';
import { addCustomerToCache } from "../../Redux/customerSlice";
import { updateBelanceInCache } from "../../Redux/belanceSlice";
import { updateStockInCache } from "../../Redux/stockSlice";
import AddAddress from "../../../assets/icon/address.png";
import { getSettings } from "../../Redux/settingSlice";
import { FormattedMessage,useIntl } from "react-intl";
import { useShowAlert  } from "../../../warrper";
export default function AddPurchase({
  settings,
  setsettings,
  AddItemModal,
  // setAddAccountModal,
  close,
  // customers,
  options1,
  records,
  setRecords,
  belance,
  moneys,
  setAddBalanceModal,
}) {
  const showAlert = useShowAlert(); 
  // const dispatch=useDispatch();
    // const { stocks, error,statusStock } = useSelector((state) => state.stocks);
    // const { money, errorm } = useSelector((state) => state.moneys);
    // const [customer,setcustomer]=useState([]);
  const { sidebars } = useSelector((state) => state.sidebars);
  console.log(sidebars);
    const { formatMessage } = useIntl();
    const [selectedDay, setSelectedDay] = useState(moment());
  const [selectedDay1, setSelectedDay1] = useState(moment());
  const [selectedOption, setSelectedOption] = useState();
  const [selectedOption1, setSelectedOption1] = useState(
);
  const [EndDate, setEndDate] = useState(moment());
  const [account, setaccount] = useState(false);
  const [ExestQty,setExestQty] = useState(0);
  const [update, setupdate] = useState({ id: 0, belance: 0 });
  const [selectedOptionAccount, setSelectedOptionAccount] = useState([]);
  // const { customers, errorc,statusc } = useSelector((state) => state.customers);
    // const { settings, errors,statuss } = useSelector((state) => state.settings);
  
  // const [settings,statusc]=useSelector((state)=>state.settings)
    // useEffect(() => {
    // //   // بررسی و بارگذاری `belances`
    // //   // if (!statusb && belances?.lenght ===0) {
    // //   //   dispatch(getBelances());
    // //   // }
    
    // //   // // بررسی و بارگذاری `moneys`
    // //   // if (!statusm && moneys?.lenght ===0) {
    // //   //   dispatch(getMoneys());
    // //   // }
    
    // //   // بررسی و بارگذاری `customers`
    // //   if (!statusc) {
    // //     dispatch(getCustomers());
    // //   }
    
    //   if(!statuss && settings?.lenght ===0) {
    //     dispatch(getSettings());
    //   }
    // }, [dispatch,statuss]);
  
  const [AddItem, setAddItem] = useState({
    stocks_id: "",
    qty: null,
    weight: null,
    dateInsert: new Date().toISOString(),
    rate: null,
    user_id: localStorage.getItem("userTokenid"),
    purchase_price:null,
    description: "",
    sell_price: null,
    expiry_date: new Date().toISOString(),
    accounts_id: "",
    money: 1,
    stock: { name: "" },
    e_id: 1,
  });
  // console.log(items);
  const [shopingcart, setshopingcart] = useState([]);
  const [TotalAmount, setTotalAmount] = useState(0);

  const [primari, setprimari] = useState(0);

  const Onsearch = (e) => {
    if (e) {
      setupdate({
        ...update,
        id: e.id,
      });
      setAddItem({
        ...AddItem,
        money: e.type_id,
      });
    }
  };
  const algorithm = (e) => {
    if (e) {
      setAddItem({
        ...AddItem,
        accounts_id: e.id,
      });
    }
  };
  const algorithm1 = (e) => {
    setSelectedOption1(e);
    if (e) {
      setAddItem({
        ...AddItem,
        stocks_id: e.id,
        stock: e,
      });
    }
  };
  const handle_date = (jalaliDate) => {
    if (jalaliDate) {
      const { year, month, day } = jalaliDate;
      const gregorianDate = jalaali.toGregorian(year, month, day);
      // Get current time
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      // Create the ISO date string
      let isoDateString;
      const t = new Date();
      const date = new Date(
        jalaliDate.year,
        jalaliDate.month - 1,
        jalaliDate.day,
        t.getHours(),
        t.getMinutes()
      );

      // const date = new Date(jalaliDate.year, jalaliDate.month - 1, jalaliDate.day);
      const isoString = date.toISOString(); // This gives you the ISO string in UTC
      // setIsoDate(isoString);
      setAddItem({
        ...AddItem,
        dateInsert: isoString,
      });
      // const isoDateString = `${year}-${month}-${day}T${hours}:${minutes}`;
    }
  };
  const date = (d) => {
    const date = new Date(d);
    let formattedDate = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    let aa = ampm;
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    if (localStorage.getItem("date") === "Persian") {
      moment.locale("fa"); // تنظیم لوکال به فارسی
      aa = hours >= 12 ? "ب.ظ" : "ق.ظ";
      formattedDate = moment(d).format("jYYYY-jMM-jDD");
    } else {
      moment.locale("en"); // تنظیم لوکال به انگلیسی
    }

    return `${formattedDate} ${formattedHours}:${formattedMinutes} ${aa}`;
  };

  // const generateInvoicePDF = (id) => {
  //   const doc = new jsPDF();

  //   // Title Section
  //   doc.setFontSize(26);
  //   doc.setFont("helvetica", "bold");
  //   doc.setTextColor(41, 128, 185); // Blue color for title
  //   doc.text("Invoice", 105, 10, null, null, "center");

  //   doc.setFontSize(14);
  //   doc.setFont("helvetica", "normal");
  //   doc.setTextColor(0, 0, 0); // Black color for text
  //   doc.text(`${settings[0].company_name}`, 105, 20, null, null, "center");
  //   doc.setFontSize(12);
  //   doc.text(
  //     `Seller Name: ${selectedOption ? selectedOption.name : "N/A"}`,
  //     105,
  //     28,
  //     null,
  //     null,
  //     "center"
  //   ); // Move to new position

  //   // Invoice Details Section
  //   doc.setFontSize(14);
  //   doc.setTextColor(41, 128, 185); // Blue color for the section heading
  //   doc.text(`Invoice Number: ${id}`, 5, 19);
  //   doc.text(`Date: ${selectedDay ? date(selectedDay) : "N/A"}`, 5, 29);

  //   // رسم یک خط افقی
  //   doc.setDrawColor(0, 0, 0); // رنگ خط (مشکی)
  //   doc.setLineWidth(0.5); // ضخامت خط
  //   doc.line(5, 35, 205, 35); // موقعیت شروع و پایان خط افقی (x1, y1, x2, y2)

  //   // Company Info Section (Header)
  //   // Customer Info Section - move these details below the title (where the image was before)
  //   // doc.setTextColor(0, 0, 0); // Black color for customer info
  //   // doc.text(`Money Type: ${selectedOptionmoney ? selectedOptionmoney.name : 'N/A'}`, 110, 60);  // Move to new position
  //   // doc.text(`Date of Purchase: ${selectedDay ? date(selectedDay) : 'N/A'}`, 110, 70);  // Move to new position

  //   // Company Image (Logo) in the top-right corner (positioned at 150, 30)
  //   if (settings[0].company_pic) {
  //     const url = settings[0].company_pic;
  //     const fileName = url.split("/").pop();
  //     doc.addImage(
  //       Source.getAddress() + "/api/getImage/" + fileName,
  //       "JPEG",
  //       180,
  //       5,
  //       25,
  //       25
  //     ); // Logo in top-right
  //   } else {
  //     doc.setFontSize(12);
  //     doc.text("No Company Image Available", 150, 20);
  //   }

  //   // Table with Purchase Details
  //   doc.autoTable({
  //     startY: 40,
  //     head: [["No", "Name", "Quantity", "Price", "Total"]],
  //     body: shopingcart.map((row) => [
  //       row.e_id,
  //       row.stock.name,
  //       row.qty,
  //       row.sell_price +
  //         `${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}`,
  //       row.sell_price * row.qty +
  //         `${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}`,
  //     ]),
  //     theme: "grid",
  //     headStyles: {
  //       fillColor: [41, 128, 185],
  //       textColor: [255, 255, 255],
  //       fontSize: 12,
  //       fontStyle: "bold",
  //     },
  //     bodyStyles: {
  //       fontSize: 10,
  //       textColor: [0, 0, 0],
  //       fillColor: [255, 255, 255],
  //     },
  //     alternateRowStyles: {
  //       fillColor: [245, 245, 245], // Light gray for alternate rows
  //     },
  //     margin: { top: 180 },
  //   });

  //   // Footer Section
  //   // doc.setFontSize(10);
  //   // doc.setTextColor(41, 128, 185); // Blue color for footer

  //   // doc.text("Thank you for your business!", 105, doc.lastAutoTable.finalY + 60, null, null, 'center');

  //   // Amount Details Section
  //   doc.setFontSize(13);
  //   doc.setTextColor(41, 128, 185); // Blue color for amount section
  //   // doc.text("Amount Details", 20, doc.lastAutoTable.finalY + 10);

  //   // Display Total, Paid, and Remaining Amount
  //   doc.setTextColor(0, 0, 0); // Black color for amounts
  //   doc.text(
  //     `Total Amount: ${TotalAmount}` +
  //       `${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}`,
  //     10,
  //     doc.lastAutoTable.finalY + 220
  //   );
  //   doc.text(
  //     `Paid Amount: ${PaidAmount ? PaidAmount : "0.00"}` +
  //       `${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}`,
  //     80,
  //     doc.lastAutoTable.finalY + 220
  //   );
  //   doc.text(
  //     `Remaining Amount: ${update.belance}` +
  //       `${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}`,
  //     135,
  //     doc.lastAutoTable.finalY + 220
  //   );

  //   // رسم یک خط افقی
  //   doc.setDrawColor(0, 0, 0); // رنگ خط (مشکی)
  //   doc.setLineWidth(0.5); // ضخامت خط
  //   doc.line(5, 280, 205, 280); // موقعیت شروع و پایان خط افقی (x1, y1, x2, y2)

  //   doc.setFontSize(12);
  //   doc.setFont("helvetica", "normal");
  //   doc.setTextColor(0, 0, 0); // Black color for text
  //   doc.text(`Address: ${settings[0].address}`, 10, 290);
  //   doc.text(`Phone: ${settings[0].phone}`, 80, 290);
  //   doc.text(`Email: ${settings[0].email}`, 140, 290);

  //   // Save the document as a PDF
  //   // doc.save("Invoice.pdf");
  //   const pdfURL = doc.output("bloburl");
  //   const printWindow = window.open(pdfURL, "_blank");
  //   // printWindow.focus();
  //   printWindow.print();
  // };
  const capitalizeWords = (text) => {
    return text
      .toLowerCase() // همه حروف را کوچک کنید
      .split(" ") // متن را به آرایه‌ای از کلمات تقسیم کنید
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // حروف اول هر کلمه را بزرگ کنید
      .join(" "); // کلمات را به هم وصل کنید
  };

  const generateInvoicePDF = (id) => {
    // Function to format date (with Persian date support)
    const dateObj = new Date(selectedDay);
    let formattedDate = `${dateObj.getFullYear()}-${String(
        dateObj.getMonth() + 1
    ).padStart(2, "0")}-${String(dateObj.getDate()).padStart(2, "0")}`;
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    let aa = ampm;

    if (settings[0].date === "Persian") {
        moment.locale("fa");
        formattedDate = moment(selectedDay).format("jYYYY/jMM/jDD");
    } else {
        moment.locale("en");
    }
    formattedDate = `${formattedDate} ${formattedHours}:${formattedMinutes} ${aa}`;

    // Get the company image URL
    const imageUrl = settings[0]?.company_pic;
    let imageSrc = "";
    if (imageUrl) {
        const fileName = imageUrl.split("/").pop();
        imageSrc = Source.getAddress() + "/api/getImage/" + fileName;
    }

    // Generate the HTML content
    const invoiceHTML = `
    <html>
        <head>
            <title>Invoice</title>
            <style>
                body {
                    font-family: Helvetica, sans-serif;
                    font-size: 12px;
                }

                .invoice-container {
                    width: 210mm;
                    height: auto;
                    padding: 10mm;
                    box-sizing: border-box;
                    background: #fff;
                }

                .header {
                    text-align: center;
                    margin-bottom: 20px;
                }

                .invoice-details {
                    margin-bottom: 15px;
                }

                table {
                    width: 100%;
                    border-collapse: collapse;
                    border: 1px solid #000;
                }

                th,
                td {
                    border: 1px solid #000;
                    padding: 5px;
                    text-align: left;
                }

                th {
                    background-color: rgb(11, 105, 255);
                    color: #fff;
                    font-size: 12px;
                }

                td {
                    font-size: 12px;
                    color: #000;
                }

                .amount-details {
                    text-align: right;
                    margin-bottom: 20px;
                }

                .footer {
                    text-align: center;
                }

                .logo {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    width: 30mm;
                }

                .even-row {
                    background-color: #f5f5f5;
                }

                .odd-row {
                    background-color: #fff;
                }
            </style>
        </head>

        <body>
            <div class="invoice-container">
                <div class="header">
                    <h1 style="font-size: 26px; font-weight: bold; color: rgb(11,105,255); margin: 0;">Invoice</h1>
                    <h2 style="font-size: 14px; margin: 5px 0; color: #000;">${settings[0].company_name}</h2>
                    </div>
                    
                    <div class="invoice-details">
                    <p style="font-size: 12px; margin: 0;">Customer Name: ${selectedOption ? capitalizeWords(selectedOption.name) : "N/A"}</p>
                    <p style="font-size: 14px; color: rgb(11,105,255); margin: 0;">Invoice Number: ${id}</p>
                    <p style="font-size: 12px; margin: 0;">Date: ${formattedDate}</p>
                </div>

                <hr style="border: 0; border-top: 1px solid #000; margin-bottom: 15px;">

                <div style="margin-bottom: 20px;">
                    <table style="width: 100%; border-collapse: collapse;" border="1" cellspacing="0" cellpadding="5">
                        <thead style="background-color: rgb(11,105,255); font-size: 12px;">
                            <tr>
                                <th>No</th>
                                <th>Name</th>
                                <th>Quantity</th>
                                <th>Price</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody style="font-size: 12px; color: #000;">
                            ${shopingcart
                                .map(
                                    (row, index) => `
                                    <tr class="${index % 2 === 0 ? 'odd-row' : 'even-row'}">
                                        <td>${index+1}</td>
                                        <td>${row.stock.name}</td>
                                        <td>${row.qty}</td>
                                        <td>${row.purchase_price} ${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}</td>
                                        <td>${row.purchase_price * row.qty} ${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}</td>
                                    </tr>
                                `
                                )
                                .join("")}
                        </tbody>
                    </table>
                </div>

                <div class="amount-details">
                    <p style="margin: 0;">Total Amount: ${TotalAmount} ${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}</p>
                    <p style="margin: 0;">Paid Amount: ${PaidAmount ? PaidAmount : "0.00"} ${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}</p>
                    <p style="margin: 0;">Balance: ${update.belance} ${selectedOptionmoney ? selectedOptionmoney.name : "N/A"}</p>
                </div>

                <hr style="border: 0; border-top: 1px solid #000; margin-bottom: 15px;">

                <div class="footer">
                    <p style="margin: 0;">Address: ${settings[0].address}</p>
                    <p style="margin: 0;">Phone: ${settings[0].phone}</p>
                    <p style="margin: 0;">Email: ${settings[0].email}</p>
                </div>
                 ${imageSrc ? `<img class="logo"  src="${imageSrc}" alt="Company Logo"/>` : ''}
            </div>
        </body>
    </html>
`;



    // Open a new tab/window
    const printWindow = window.open('', '_blank');
    if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(invoiceHTML);
        printWindow.document.close();

        // Wait for content to load in the new window
        printWindow.onload = () => {
            printWindow.focus(); // Focus on the new window
            printWindow.print(); // Open the print dialog
            printWindow.close(); // Close the new window
        };
    } else {
        alert('Please allow pop-ups for this website to print the invoice.');
    }
};

  const Sumbit = (flag) => {
    console.log(selectedOption);
    if (!Exesting && update.belance != 0) {
      showAlert({
        position: "top-end",
        icon: "error",
        title: "You don't have enough belance!",
        showConfirmButton: false,
        timer: 1000,
      });
      return;
    }
    if (!selectedOptionmoney || shopingcart.length <= 0) {
      showAlert({
        position: "top-end",
        icon: "error",
        title: "You must fill the item input!",
        showConfirmButton: false,
        timer: 1000,
      });
      return;
    }

// has problem in add purchase in customer name and the report benefit also had
        if ( !selectedOption?.id && 
          Exesting
        ) {
      showAlert({
        position: "top-end",
        icon: "error",
        title: "You must fill the save the customer!",
        showConfirmButton: false,
        timer: 1000,
      });
      return;
    }

    let arr = [];
    // console.log(shopingcart);
    shopingcart.forEach((key) => {
      // console.log(key.item);
      // dispatch(updateStockInCache(key.item));
      // console.log(stocks)
      arr.push({
        stocks_id: key.stocks_id,
        qty: key.qty,
        weight: key.weight,
        dateInsert: key.dateInsert,
        rate: key.rate,
        user_id: key.user_id,
        purchase_price: key.purchase_price,
        description: key.description,
        sell_price: 0,
        expiry_date: key.expiry_date,
        accounts_id: key.accounts_id,
      });
    });
    let add = { arr: arr };
    let selectedMoney=selectedOptionmoney;
    let selectedop=selectedOption;
    let pa = PaidAmount;
    let ta=TotalAmount;
    let sd=selectedDay;
    setSelectedOptionmoney(null);
        setshopingcart([]);
        setSelectedDay(moment());
        setSelectedOption(null);
        setupdate({ id: 0, belance: 0 });
        setTotalAmount(0);
        setPaidAmount(0);
        setExestQty(0);
    axios
      .post(Source.getAddress() + "/api/purchase", add, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
        params: {
          Exesting: Exesting ? "ok" : "no",
          money: 1,
          accounts_id:selectedop ? (selectedop.id!==0 ? selectedop.id :'no') : 'no',
          PaidAmount: pa ? pa : 0,
          TotalAmount: ta,
          CustomerName: selectedop.name,
          DateInsert: sd,
        },
      })
      .then((res) => {
        console.log(res);
        let result = res.data.bill;
        if (flag) {
          generateInvoicePDF(result.id);
        }
        result["money"] = selectedMoney;
        if(Exesting){
          result['accounts']={account:selectedop};
        }
        let add = {
          purchase: shopingcart,
          bill: res.data.bill,
          money: selectedMoney,
        };
        setRecords([add, ...records]);
        
        showAlert({
          position: "top-end",
          icon: "success",
          // title: "Stock has been created!",
                                  title: <FormattedMessage id="Your record has been added!" />,
          showConfirmButton: false,
          timer: 1000,
        });
      })
      .catch((err) => {
        console.log(err);
        showAlert({
          position: "top-end",
          icon: "error",
          // title: "Something went wrong!",
                  title:  <FormattedMessage id="You must enter the customer name!" />
          ,
          showConfirmButton: false,
          timer: 1000,
        });
      });
  };
  const AddtoTable = () => {
    // بررسی اینکه تمام فیلدهای ضروری پر شده‌اند
    const qty = AddItem.qty ? parseFloat(AddItem.qty) : 0;
    const purchasePrice = AddItem.purchase_price ? parseFloat(AddItem.purchase_price) : 0;
    if (!qty || !purchasePrice || !selectedOption1) {
      showAlert({
        position: "top-end",
        icon: "error",
                  title:  <FormattedMessage id="Please select an item and fill the quantity and price!" />,
        showConfirmButton: false,
        timer: 1000,
      });
      return;
    }
    // اطمینان از مقدار مثبت برای موجودی
    if (qty <= 0 || purchasePrice <= 0) {
      showAlert({
        position: "top-end",
        icon: "error",
        // title: "Quantity and price must be positive values!",
                  title:  <FormattedMessage id="Quantity and price must be positive values!" />,
        
        showConfirmButton: false,
        timer: 1000,
      });
      return;
    }
    // ایجاد نسخه کپی از AddItem و selectedOption1
    const addto = { ...AddItem, item: { ...selectedOption1 } };
    addto.item.qty = selectedOption1.qty
      ? qty + parseFloat(selectedOption1.qty)
      : qty;
  
    // افزودن آیتم به سبد خرید
    setshopingcart((prev) => [...prev, addto]);
  
    // به‌روزرسانی مقادیر کل
    setTotalAmount((prev) => prev + qty * purchasePrice);
    setPaidAmount((prev) => prev + qty * purchasePrice);
  
    // بازنشانی مقدار AddItem
    setAddItem({
      stocks_id: "",
      qty: "",
      weight: null,
      dateInsert: new Date().toISOString(),
      rate: null,
      user_id: localStorage.getItem("userTokenid"),
      purchase_price: "",
      description: "",
      sell_price: null,
      expiry_date: new Date().toISOString(),
      accounts_id: "",
      money: "",
      stock: { name: "" },
      e_id: AddItem.e_id + 1,
    });
  
    // بازنشانی selectedOption1
    setSelectedOption1(null);
  };
  
  const AddAccountModal = (name) => {
    let add = { name: name,
      user_id:localStorage.getItem('userTokenid')
     };
    axios
      .post(Source.getAddress() + "/api/customers", add, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      })
      .then((res) => {
        setSelectedOption(res.data.customer);
        setOptions([res.data.customer,...options]);
        showAlert({
          position: "top-end",
          icon: "success",
          title: "Customer has been created!",
          showConfirmButton: false,
          timer: 1000,
        });
        // dispatch(addCustomerToCache(res.data.customer))
        
      })
      .catch((err) => {
        // console.log(err);
        showAlert({
          position: "top-end",
          icon: "error",
          title: "Sosmething went wrong!",
          showConfirmButton: false,
          timer: 1000,
        });
      });
      // dispatch(getCustomers());
  };
  const handleItem = (e) => {
    setAddItem({
      ...AddItem,
      [e.target.name]: e.target.value,
    });
  };
  const [options, setOptions] = useState([]);
  // const [options1, setOptions1] = useState(stocks);
  const handleSearch = async (query) => {
    if (!Exesting) {
      // if (query.length < 1) {
      //   // برای جلوگیری از ارسال درخواست بیش از حد، درخواست فقط اگر ورودی بیشتر از 2 حرف باشد ارسال شود
      //   setOptions([]);
      //   return;
      // }
      // try {
        // setOptions(customers);

        // const response = await axios.get(
        //   `${Source.getAddress()}/api/customers`,
        //   {
        //     headers: {
        //       Authorization: `Bearer ${localStorage.getItem("access")}`,
        //     },
        //     params: { query: query }, // ارسال پارامتر جستجو به سرور
        //   }
        // );
        // //   console.log(query);
        // const data = response.data;
        // // تبدیل داده‌ها به فرمت مناسب برای react-select
        // let formattedOptions = data;
        // setOptions(customers);
        // if (formattedOptions.length() === 0) {
          if (query) {
            setAddItem({
              ...AddItem,
              temp_customer: query,
            });
            setSelectedOption({ id: null, name: query });
          }
        // }
      // } catch (error) {
      //   console.error("Error fetching data:", error);
      // } finally {
      // }
    }
  };

  const handleSearch1 = async (query) => {
    // if (query.length < 1) {
    //   // برای جلوگیری از ارسال درخواست بیش از حد، درخواست فقط اگر ورودی بیشتر از 2 حرف باشد ارسال شود
    //   setOptions1([]);
    //   return;
    // }
    // try {
    //   const response = await axios.get(`${Source.getAddress()}/api/item`, {
    //     headers: {
    //       Authorization: `Bearer ${localStorage.getItem("access")}`,
    //     },
    //     params: {
    //       query: query,
    //     },
    //   });
    //   const data = response.data;
    //   // console.log(data);
    //   // تبدیل داده‌ها به فرمت مناسب برای react-select
    //   const formattedOptions = data;
    //   setOptions1(formattedOptions);
    // } catch (error) {
    //   console.error("Error fetching data:", error);
    // } finally {
    // }
  };
  const handleInputChange = (newValue) => {
    setSearchQuery(newValue); // بروزرسانی مقدار ورودی جستجو
    handleSearch(newValue); // ارسال درخواست جستجو به سرور
  };
  const handleInputChange1 = (newValue) => {
    // setExestQty(newValue && newValue.qty);
    setSearchQuery1(newValue); // بروزرسانی مقدار ورودی جستجو
    handleSearch1(newValue); // ارسال درخواست جستجو به سرور
  };
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQuery1, setSearchQuery1] = useState("");

  const [selectedOptionmoney, setSelectedOptionmoney] = useState({ name: "" });
  const algorithmmoney = (e) => {
    if (e) {
      setAddItem({
        ...AddItem,
        money: e.id,
      });
    }
  };

  const Deleteshopingcart = (e) => {
    setupdate({
      ...update,
      belance:update.belance - e.qty * e.sell_price
    })
    setTotalAmount((prev) => prev - e.qty * e.purchase_price);
    setPaidAmount((prev) => prev - e.qty * e.purchase_price);
    setshopingcart((prev) => prev.filter((pre) => pre.e_id !== e.e_id));
  };
  const buttonRef = useRef(null);
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (buttonRef.current && AddItemModal) {
        buttonRef.current.click();
      }
    }
  };
  const [PaidAmount, setPaidAmount] = useState(0);
  const handlepaid = (e) => {
    setPaidAmount(e.target.value);
  };
  useEffect(() => {
    // if (PaidAmount) {
    // const total = Number(TotalAmount) || 0;
    // const paid = Number(PaidAmount) || 0;
    if (!PaidAmount) {
      setupdate((prevState) => ({
        ...prevState,
        belance: -TotalAmount,
      }));
    } else {
      setupdate((prevState) => ({
        ...prevState,
        belance: PaidAmount - TotalAmount || 0,
      }));
    }

    // }
  }, [PaidAmount, TotalAmount, shopingcart]);
  // useEffect(()=>{
  //   if(Exesting){
      // setOptions(customers);
  //   }else{
  //     setOptions([]);
  //   }
  // },[Exesting])
  const [Exesting, setExesting] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${Source.getAddress()}/api/customers`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
          params: { query:searchQuery ,do:'ok'}, // ارسال پارامتر جستجو به سرور
        });
        // setSelectedOption(response.data);
        const data = response.data;
        setOptions(data);
        // console.log('hhi');
  
        // if (data && data.length === 0) {
        //   setSelectedOptionTo({ id: 0, name: searchQueryTo });
        // } else {
        //   setOptionsTo(data); // ذخیره داده‌ها برای نمایش در لیست
        // }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    if(searchQuery){
      if (!searchQuery || searchQuery?.length < 3) {
        setOptions([]);
        return;
      }else{
    if (Exesting) {
        fetchData();}
      }
    }
  }, [searchQuery]); // اضافه کردن searchQuery به وابستگی‌های useEffect

    return (<div
      dir={localStorage.getItem("language") === "en" ? "ltr" : "rtl"}
      className={`container rounded-5 popup transition ${account && "sellpurchase"} ${AddItemModal ? "show" : ""}`}
      style={{
        width: "100%",
        maxWidth: "95% !important",
        overflowX: "auto",
        overflowY: "auto",
        height: "75vh",
        backgroundColor: "#f8f9fa",
        padding: "5px",
      }}
    >
      <div className="d-flex justify-content-end align-items-center mt-2">
        <h2
          className="text-center rounded p-1 text-light"
          style={{
            backgroundColor: "var(--bs-info)",
            width: "100%",
            margin: "0",
            fontSize: "1rem",
          }}
        >
          <FormattedMessage id="Add Purchase" />
        </h2>
        <button
          type="button"
          className="btn-close p-2 mt-0 hover_btn"
          onClick={close}
          aria-label="Close"
        ></button>
      </div>
    
      <div className="p-1 rounded-5">
        <div style={{ marginTop: "0.5rem", overflow: "auto" }}>
          {/* Customer Info Section */}
          <div
            className="rounded-3 px-3 p-1 mb-2"
            style={{
          boxShadow: "0px 4px 0px 0 rgba(0, 0, 0, 0.2), 0 0px 0px 0px rgba(0, 0, 0, 0.1)"
              // boxShadow: "2px 2px 2px 0 rgba(0, 0, 0, 0.2), 0 0px 2px 2px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h2 className="mt-1" style={{ fontSize: "0.9rem" }}>
              <FormattedMessage id="Customer Info" />
            </h2>
            <div className="d-flex flex-column flex-md-row mb-2 mt-1">
              <div className="form-check form-switch p-0 center mb-2 me-3" style={{ width: "5rem", height: "1rem" }}>
                <label htmlFor="validationServer01" className="fw-bold" style={{ fontSize: "0.8rem" }}>
                  <FormattedMessage id="Exesting" />
                </label>
                <input
                  className="form-check-input align-bottom m-0 w-100 h-75 mt-1 ms-1"
                  type="checkbox"
                  id="report"
                  checked={Exesting}
                  onChange={(e) => setExesting(e.target.checked)}
                />
              </div>
              <div className="form-item me-2 w-100 w-md-auto">
                <label htmlFor="validationServer01" className="fw-bold" style={{ fontSize: "0.8rem" }}>
                  <FormattedMessage id="Customer Name" />
                </label>
                <Combo_stock
                  name={<FormattedMessage id="Add Customer" />}
                  setAddAccountModal={AddAccountModal}
                  type={Exesting}
                  searchQuery={searchQuery}
                  handleInputChange={handleInputChange}
                  setSelectedOption={setSelectedOption}
                  selectedOption={selectedOption}
                  options={options}
                  Onsearch={algorithm}
                  compactMode={true}
                />
              </div>
              {/* <div className="form-item me-2 w-100 w-md-auto">
                <label htmlFor="phone_number" style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                  <FormattedMessage id="Currency" />
                </label>
                <Combo_Customer
                  isEditable={account}
                  setSelectedOption={setSelectedOptionmoney}
                  selectedOption={selectedOptionmoney}
                  options={moneys}
                  Onsearch={algorithmmoney}
                  compactMode={true}
                />
              </div> */}
              <div className="date-picker-container w-100 w-md-auto">
                <Datepicker_Customer
                  default_value={EndDate}
                  handle_date={handle_date}
                  lebal={<FormattedMessage id="Date" />}
                  setSelectedDay={setSelectedDay}
                  selectedDay={selectedDay}
                  compactMode={true}
                />
              </div>
            </div>
          </div>
    
          {/* Item Information Section */}
          <div
            className="rounded-3 px-3 p-1 mb-2"
            style={{
          boxShadow: "0px 4px 0px 0 rgba(0, 0, 0, 0.2), 0 0px 0px 0px rgba(0, 0, 0, 0.1)"

              // boxShadow: "2px 2px 2px 0 rgba(0, 0, 0, 0.2), 0 0px 2px 2px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h2 className="mt-1" style={{ fontSize: "0.9rem" }}>
              <FormattedMessage id="Item information" />
            </h2>
            <div className="d-flex flex-column flex-md-row mb-2 mt-1">
              <div className="me-2 w-100 w-md-14rem">
                <label htmlFor="validationServer01" className="fw-bold" style={{ fontSize: "0.8rem" }}>
                  <FormattedMessage id="Item Name" />
                </label>
                <Combo_stockps
                  searchQuery={searchQuery1}
                  setSearchQuery={setSearchQuery1}
                  handleInputChange={handleInputChange1}
                  handleSearch={handleSearch1}
                  setSelectedOption={algorithm1}
                  selectedOption={selectedOption1}
                  options={options1}
                  compactMode={true}
                />
              </div>
              <div className="me-2 w-100 w-md-5rem">
                <label htmlFor="phone_number" style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                  <FormattedMessage id="Quantity" />
                </label>
                <input
                  onKeyDown={handleKeyDown}
                  onChange={handleItem}
                  value={AddItem.qty}
                  type="number"
                  name="qty"
                  placeholder={formatMessage({ id: "Quantity" })}
                  className="form-control mb-2"
                  style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
                />
              </div>
              <div className="me-2 w-100 w-md-7rem">
                <label htmlFor="phone_number" style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                  <FormattedMessage id="Purchase Price" />
                </label>
                <input
                  onKeyDown={handleKeyDown}
                  onChange={handleItem}
                  value={AddItem.purchase_price}
                  type="number"
                  name="purchase_price"
                  placeholder={formatMessage({ id: "Purchase Price" })}
                  className="form-control mb-2"
                  style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
                />
              </div>

              
              {sidebars.type==="gold" &&(
              <div className="me-2 w-100 w-md-7rem">
                <label htmlFor="phone_number" style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                  <FormattedMessage id="weight" />
                </label>
                <input
                  onKeyDown={handleKeyDown}
                  onChange={handleItem}
                  value={AddItem.purchase_price}
                  type="number"
                  name="weight"
                  placeholder={formatMessage({ id: "Purchase Price" })}
                  className="form-control mb-2"
                  style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
                />
              </div>
)}

              <div className="me-2 w-100 w-md-8rem">
                <label htmlFor="phone_number" style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                  <FormattedMessage id="Total Amount" />
                </label>
                <input
                  readOnly={true}
                  value={AddItem.qty * AddItem.purchase_price}
                  type="text"
                  className="form-control mb-2"
                  style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
                />
              </div>
              <div className="me-2 w-100 w-md-8rem">
                <label htmlFor="phone_number" style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                  <FormattedMessage id="Exest QTY" />
                </label>
                <input
                  readOnly={true}
                  value={selectedOption1 ?  selectedOption1?.qty ? parseFloat(AddItem.qty||0) + parseFloat(selectedOption1.qty):"" : ''}
                  type="text"
                  className="form-control mb-2"
                  style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
                />
              </div>
              {selectedOption1 !== null && selectedOption1?.type?.measuring.includes("Weight") && (
                <div className="me-2 w-100 w-md-auto">
                  <label htmlFor="phone_number" style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                    <FormattedMessage id="Weight" />
                  </label>
                  <input
                    onChange={handleItem}
                    type="number"
                    name="weight"
                    className="form-control mb-2"
                    style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
                  />
                </div>
              )}
              <div className="form-floating w-100 w-md-15rem">
                <textarea
                  name="description"
                  className="form-control"
                  style={{ fontSize: "0.8rem", minHeight: "40px" }}
                  value={AddItem.description}
                  onChange={handleItem}
                />
                <label htmlFor="floatingTextarea2" style={{ fontSize: "0.8rem" }}>
                  <FormattedMessage id="Description" />
                </label>
              </div>
              <button
                onClick={() => AddtoTable()}
                type="button"
                className="btn btn-success p-1 m-2 w-100 mb-0  w-md-6rem mt-3 h-25"
                style={{ fontSize: "0.8rem" }}
              >
                <img src={Add} style={{ width: "15px", height: "15px" }} alt="Add" />
              </button>
            </div>
          </div>
        </div>
      </div>
    
      {/* Bottom Section */}
      <div className="row m-0 p-0">
        <div className="col-12 col-md-8">
          <div className="row" style={{ maxHeight: '300px', overflow: "auto" }}>
            <h3
              className="text-center rounded p-1 text-light"
              style={{
                backgroundColor: "var(--bs-info)",
                width: "100%",
                margin: "0",
                fontSize: "0.9rem",
              }}
            >
              <FormattedMessage id="Purchase stocks" />
            </h3>
            <div className="table-responsive">
              <table className="table table-light table-striped" style={{ fontSize: "0.8rem" }}>
                <thead>
                  <tr>
                    <th scope="col" style={{ width: "5%" }}><FormattedMessage id="ID" /></th>
                    <th scope="col" style={{ width: "20%" }}><FormattedMessage id="Name" /></th>
                    <th scope="col" style={{ width: "10%" }}><FormattedMessage id="Quantity" /></th>
                    <th scope="col" style={{ width: "10%" }}><FormattedMessage id="Price" /></th>
                    <th scope="col" style={{ width: "10%" }}><FormattedMessage id="Total" /></th>
                    <th scope="col" style={{ width: "30%" }}><FormattedMessage id="Description" /></th>
                    <th scope="col" style={{ width: "5%" }}><FormattedMessage id="Delete" /></th>
                  </tr>
                </thead>
                <tbody className="table-group-divider">
                  {shopingcart && shopingcart.map((row, idx) => (
                    <tr key={idx}>
                      <th scope="row">{row.e_id}</th>
                      <td>{row.stock.name}</td>
                      <td>{row.qty}</td>
                      <td>{row.purchase_price}</td>
                      <td>{row.purchase_price * row.qty}</td>
                      <td>{row.description}</td>
                      <td>
                        <button
                          style={{ border: "none", background: "transparent" }}
                          onClick={() => Deleteshopingcart(row)}
                        >
                          <img height={"40%"} width={"40%"} src={Trash} alt="Delete" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>\
            </div>
          </div>
        </div>
    
        <div className="col-12 col-md-4">
          <label htmlFor="phone_number" style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
            <FormattedMessage id="Total Amount" />
          </label>
          <input
            readOnly={true}
            value={TotalAmount}
            type="text"
            className="form-control mb-1"
            style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
          />
          <label htmlFor="phone_number" style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
            <FormattedMessage id="Paid Amount" />
          </label>
          <input
            readOnly={!Exesting}
            onChange={handlepaid}
            value={PaidAmount}
            type="text"
            className="form-control mb-1"
            style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
          />
          <label htmlFor="phone_number" style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
            <FormattedMessage id="Remain Balance" />
          </label>
          <input
            readOnly={true}
            value={update.belance}
            type="number"
            className="form-control mb-1"
            style={{ width: "100%", fontSize: "0.8rem", padding: "0.2rem" }}
          />
          <div className="col-12 d-flex justify-content-center mt-3">
            <button
              type="button"
              className="text-center btn btn-danger text-light me-1 ms-1"
              style={{ width: "120px", fontSize: "0.8rem", padding: "0.2rem" }}
              onClick={close}
            >
              <FormattedMessage id="Cancel" />
            </button>
            <button
              type="button"
              className="text-center btn btn-success text-light ms-1"
              style={{ width: "120px", fontSize: "0.8rem", padding: "0.2rem" }}
              onClick={() => Sumbit(false)}
            >
              <FormattedMessage id="Submit" />
            </button>
            <button
              type="button"
              className="text-center btn btn-success text-light ms-1"
              style={{ width: "120px", fontSize: "0.8rem", padding: "0.2rem" }}
              onClick={() => Sumbit(true)}
            >
              <FormattedMessage id="Print And Save" />
            </button>
          </div>
        </div>
      </div>
    </div>);}
